import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormArray, FormGroup } from '@angular/forms'
import { LineOtherIncomeComponent } from '../line-other-income/line-other-income.component';


@Component({
  selector: 'app-incomes-array',
  templateUrl: './incomes-array.component.html',
  styleUrls: ['./incomes-array.component.scss']
})

export class IncomesArrayComponent implements OnInit {
	@Input() public incomesFormArray: FormArray;
	@Input() public incomeTypes: string[];
	@Input() public displayErrors: boolean;
	@Input() public titles: string[];
    @Input() public needSources: boolean;
	@Output() onAddFormGroup: EventEmitter<any> = new EventEmitter<any>();
	@Input() public incomeType;
	@Output() onIncomesChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() public ph: string[];
	@Input() public buttons: string[];
	@Input() public qID: string;

	maxIncomesArrayLength = 4;


  constructor() { }

  	ngOnInit() {
	}

	emitIncomesChanges($event) {
	this.onIncomesChange.emit($event);
	}

	addIncome() {
		this.onAddFormGroup.emit();
		this.displayErrors = this.incomesFormArray.invalid;
			if (this.incomesFormArray.valid)
			{
				this.incomesFormArray.push(LineOtherIncomeComponent.buildIncome(''));
			}
	}

	simulateClick(event) {
		if ( event.keyCode === 13 ){
		  event.currentTarget.click();
		} 
	 }

  
	static buildIncomes(value:any) {
		let arr: FormGroup[]=[];
		if(value && value[0][0].answerValue) {
			value.forEach(element => {
				arr.push(LineOtherIncomeComponent.buildIncome(element));
			});
		}
		else{
			arr.push(LineOtherIncomeComponent.buildIncome(''));
		}
		return new FormArray(arr);
  }
}



// WEBPACK FOOTER //
// ./src/app/incomes-array/incomes-array.component.ts